import { Component, Input, OnInit, OnDestroy} from '@angular/core';
import { QueueReviewType, HHRoutingService } from 'src/app/core';
import { SecondLevelReviewHH } from '@shared/model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, finalize, map, tap, } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-do-next-queue-dialog',
    templateUrl: './do-next-queue-dialog.component.html',
    styleUrls: ['./do-next-queue-dialog.component.scss'],
    standalone: false
})
export class DoNextQueueDialogComponent implements OnInit, OnDestroy {
  loading = false;
  secondLevelRoutingData: SecondLevelReviewHH[];
  selectedRoutingOption: SecondLevelReviewHH;
  exclusiveReferences = [
    {
      description: 'To C3 Review',
      reviewValue: 'C3',
    },
    {
      description: 'To Behavioral Health Review',
      reviewValue: 'Behavioral Health',
    },
    {
      description: 'To Physician Review',
      reviewValue: 'MD',
    },
    {
      description: 'To PDS Task -1',
      reviewValue: 'PDS Team',
    },
  ];
  @Input() isVisible: boolean;
  @Input() isLoading: boolean;
  private subs: SubSink = new SubSink();

  constructor(
    private hhRoutingService: HHRoutingService,
    private ref: DynamicDialogRef,
  ) { }

  ngOnInit(): void {
    this.getReferences();
  }

  private getReferences(): void {
    this.loading = true;

    this.subs.sink = this.setSecondLevelReviews().pipe(
      finalize(() => this.loading = false),
    ).subscribe();
  }

  private setSecondLevelReviews(): Observable<boolean> {
    return this.hhRoutingService.getSecondLevelReferences().pipe(
      map(references => references['secondLevelReview'].map((description) => {
        const exclusiveReference = this.exclusiveReferences.find(reference => reference.reviewValue === description);

        return exclusiveReference
          ? exclusiveReference
          : {
            description: `To ${description}`,
            reviewValue: description,
          } as SecondLevelReviewHH;
      })),
      map(references => {
        const queueReviewExtraOptions = this.addQueueExtraOptions();

        return queueReviewExtraOptions.concat(references);
      }),
      map(references => references.filter(ref => ref.description !== 'To Clinical Review')),
      tap((references => this.secondLevelRoutingData = references)),
      map(() => true),
    );
  }

private addQueueExtraOptions(): SecondLevelReviewHH[] {
    return [
      {
        description: QueueReviewType.CompleteRemove,
        reviewValue: QueueReviewType.CompleteRemove,
      },
      {
        description: `To ${QueueReviewType.Self}`,
        reviewValue: QueueReviewType.Self,
      },
      {
        description: `To ${QueueReviewType.ResourceRouter}`,
        reviewValue: QueueReviewType.ResourceRouter,
      },
    ];
  }
  onRoute(): void {
    this.ref.close(this.selectedRoutingOption);
  }

  onCancel(): void {
    this.ref.close(null);
  }

  ngOnDestroy(){
    this.subs.unsubscribe();
  }
}
